import React from 'react'
import {FlaskConical, Leaf, ListChecks} from 'lucide-react'

function WhyItWorks() {
  const cards = [
    { icon: FlaskConical, title: 'Receitas testadas', text: 'Cada receita foi desenvolvida para entregar maciez, estrutura e sabor.' },
    { icon: Leaf, title: 'Ingredientes simples', text: 'Você não precisa de ingredientes difíceis de encontrar.' },
    { icon: ListChecks, title: 'Passo a passo completo', text: 'Mesmo iniciantes conseguem acompanhar todas as receitas.' },
  ]

  return (
    <section className="bg-[#FCFAF5] py-20 md:py-28">
      <div className="max-w-[1200px] mx-auto px-6 md:px-10">
        <div className="text-center mb-14 animate-fade-up">
          <h2 className="font-display text-[#49352B] text-3xl md:text-5xl font-bold">
            Por que nossas receitas funcionam?
          </h2>
        </div>

        <div className="grid sm:grid-cols-3 gap-8">
          {cards.map((c, i) => {
            const Icon = c.icon
            return (
              <div
                key={i}
                className="bg-white rounded-[20px] p-8 border border-[#EBD9C3] shadow-sm hover:shadow-lg transition-all duration-300 hover:-translate-y-1 animate-fade-up text-center"
              >
                <div className="w-14 h-14 rounded-full bg-[#EBD9C3] flex items-center justify-center mx-auto mb-5">
                  <Icon className="w-7 h-7 text-[#D9891B]" />
                </div>
                <h3 className="font-display text-lg font-bold text-[#49352B] mb-3">{c.title}</h3>
                <p className="text-[#49352B]/70 text-sm leading-relaxed">{c.text}</p>
              </div>
            )
          })}
        </div>
      </div>
    </section>
  )
}

export default WhyItWorks
